define('Products/ProductsCollection',["matchHeight", "jquery"],
    function (matchHeight, $) {
        function ProductsCollection() {

            //$('.product-collection-item').matchHeight();


			$('.product-collection-item').on("click", function (e) {
				e.preventDefault();
					
				var ctaLink = $(this).children('a:first-child');
				
				if (ctaLink && ctaLink.length && ctaLink.prop('href')) {
			        window.location = ctaLink.prop('href');
			    }
				
				return false;
			});						
        }

        return function InitProductsCollection(args) {
            return new ProductsCollection(args);
        };
    });
